<template>
  <div>
    <!--顶部工具条-->
    <el-col :span="24">
      <el-form :inline="true">
        <el-form-item label="">
          <el-input
            style="width: 180px"
            v-model="filters.name"
            placeholder="请输入关键字搜索"
            clearable
          ></el-input>
        </el-form-item>
         <el-form-item>
            <el-select
              style="width: 170px"
              v-model="filters.isAudit"
              placeholder="请选择审核状态"
              clearable
            >
              <el-option
                v-for="item in isAuditOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item>
            <el-select
              style="width: 170px"
              v-model="filters.isSend"
              placeholder="请选择发送状态"
              clearable
            >
              <el-option
                v-for="item in isSendOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

        <el-form-item style="margin-left: 20px">
          <toolbar
            :buttonList="buttonList"
            @callFunction="callFunction"
          ></toolbar>
        </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      border
      @current-change="selectCurrentRow"
    >
      <el-table-column
        prop="numberName"
        label="批次编号"
        align="center"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        prop="isEnable"
        label="模板名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="totalOtherPromotionCount"
        label="模板内容"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="provinceName"
        label="号码库名称"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cityName"
        label="发送时间"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="审核状态"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="发送状态"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="号码个数"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="送达率"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="点击率"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="注册率"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建日期"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <!--底部工具条-->
    <el-col :span="24" class="pageBar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>

    <!--订单新增区域新增界面-->
    <el-dialog
      :title="editmark == true ? '编辑' : '新增'"
      :visible.sync="FormVisible"
      v-model="FormVisible"
      :close-on-click-modal="false"
    >
      <div style="display: flex">
        <div class="left" style="flex: 1">
          <el-form
            :model="Form"
            label-width="100px"
            ref="addForm"
            style="max-width: 700px"
            :rules="FormRules"
          >
            <el-form-item label="项目名称：" prop="name">
              <el-input
                v-model="Form.name"
                auto-complete="off"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>

            <el-form-item label="选择地区: ">
              <el-form-item
                style="display: inline-block"
                label="省份："
                prop="provinceId"
              >
                <el-select
                  style="width: 80px"
                  clearable
                  v-model="Form.provinceId"
                  placeholder="请选择"
                  @change="handleProvinceChange"
                >
                  <el-option
                    v-for="item in provinceOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                style="display: inline-block"
                label="城市:"
                prop="cityId"
              >
                <el-select
                  style="width: 100px"
                  clearable
                  v-model="Form.cityId"
                  placeholder="请选择"
                  @change="handleCityChange"
                >
                  <el-option
                    v-for="item in cityOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                style="display: inline-block"
                label="区县："
                prop="districtId"
              >
                <el-select
                  style="width: 100px"
                  clearable
                  v-model="Form.districtId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in areaOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form-item>
            <el-form-item label="合作期限:" prop="serachTimer">
              <el-date-picker
                v-model="Form.serachTimer"
                :unlink-panels="true"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="金额(元)：" prop="amount">
              <el-input
                v-model="Form.amount"
                auto-complete="off"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="权限：">
              <el-checkbox
                v-model="Form.isWatchMainPermission"
                label="主体视频观看权限"
              ></el-checkbox>
              <el-checkbox
                v-model="Form.isLoadMainPermission"
                label="主体视频下载权限"
              ></el-checkbox>
              <el-checkbox
                v-model="Form.isLoadAccessoryPermission"
                label="附件下载权限"
              ></el-checkbox>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="FormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="FormSubmit"
          :loading="listLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import {
  getAreaDictionaryList,
  editOrderProductPromotionListPageApi,
  getOrderProductPromotionListPageApi,
  addOrderProductPromotionListPageApi,
  delOrderProductPromotionListPageApi,
  isEnablelOrderProductPromotionApi
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Qs from "qs";
export default {
  components: { Toolbar },
  data() {
    return {
      util: "",
      tableData: [],
      listLoading: false,
      //增删改查按钮
      buttonList: [],
      //顶部筛选条件
      filters: {
        name: "",
      },

      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },

      provinceOptions: [],
      cityOptions: [],
      areaOptions: [],
      pid: 0,
      FormVisible: false,
      Form: {
        name: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        serachTimer: "",
        amount: "",
        isWatchMainPermission: false,
        isLoadMainPermission: false,
        isLoadAccessoryPermission: false,
      },
      isAuditOptions:[
        {
          value:0,
          label:'未审核'
        },
         {
          value:1,
          label:'已审核'
        }
      ],
      isSendOptions:[
        {
          value:0,
          label:'平台未发送'
        },
         {
          value:1,
          label:'平台已发送'
        }
      ],
      FormRules: {
        name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        provinceId: [
          { required: true, message: "请选择省份", trigger: "blur" },
        ],
        cityId: [{ required: true, message: "请选择城市", trigger: "blur" }],
        districtId: [
          { required: true, message: "请选择区县", trigger: "blur" },
        ],
        serachTimer: [
          { required: true, message: "请选择合作期限", trigger: "blur" },
        ],
        amount: [{ required: true, message: "请输入金额", trigger: "blur" }],
      },
      currentRow: "",
      editmark: false,
    };
  },
  methods: {
    enableBtnFun() {
      console.log("enableBtnFun了");
    },
    // disableBtnFun() {
    //   console.log("disableBtnFun了");
    // },
    // 导出模板
    exportMessageExcel() {
      this.listLoading = true;
      function createObjectURL(object) {
        return window.URL
          ? window.URL.createObjectURL(object)
          : window.webkitURL.createObjectURL(object);
      }
      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      xhr.open(
        "GET",
        `/omswebapi/message/exportMessageExcel?isAll=${
          this.exportExcelRadio
        }&startDate=${
          this.rangeTimers
            ? this.formatCreateTime(this.rangeTimers[0]) + " 00:00:00"
            : null
        }&endDate=${
          this.rangeTimers
            ? this.formatCreateTime(this.rangeTimers[1]) + " 23:59:59"
            : null
        }`,
        true
      );
      xhr.setRequestHeader(
        "Authorization",
        `Bearer ${window.localStorage.getItem("Token")}`
      );
      xhr.responseType = "blob";
      xhr.onload = function (e) {
        if (this.status == 200) {
          var blob = this.response;
          var filename = `聊天记录导出.xlsx`;
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            var a = document.createElement("a");
            var url = createObjectURL(blob);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(formData);
      this.listLoading = false;
    },
    getList() {
      var params = {
        ...this.filters,
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
      };
      getOrderProductPromotionListPageApi(params).then((res) => {
        this.tableData = res.data.response.data;
        this.pages.dataCount = res.data.response.dataCount;
      });
    },

    selectCurrentRow(row) {
      this.currentRow = row;
    },

    async handleEdit() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      // 等待 DOM 渲染完成再调用 resetFields
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.resetFields();
        }
      });
      this.editmark = true;
      // 深拷贝一下
      this.Form = { ...this.currentRow };
      // 根据省份获取一下城市列表
      this.pid = this.Form.provinceId;
      await this.getProvinceCityInfo(1);
      // 根据城市列表获取一下区县列表
      this.pid = this.Form.cityId;
      await this.getProvinceCityInfo(2);
      this.FormVisible = true;
    },
    handleAdd() {
      // 等待 DOM 渲染完成再调用 resetFields
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.resetFields();
        }
      });
      this.editmark = false;
      (this.Form = {
        name: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        serachTimer: "",
        amount: "",
        isWatchMainPermission: false,
        isLoadMainPermission: false,
        isLoadAccessoryPermission: false,
      }),
        (this.FormVisible = true);
    },

    handleDel() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要删除的的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除吗？", "提示", {}).then(() => {
        this.listLoading = true;
        let params = {
          id: this.currentRow.id,
        };
        delOrderProductPromotionListPageApi(params).then((res) => {
          if (res.data.success) {
            this.listLoading = false;
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.$refs["Form"].resetFields();
            this.FormVisible = false;
            this.getList();
          } else {
            this.listLoading = false;
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        });
      });
    },

    //提交新增表单
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.listLoading = true;
            const { serachTimer, ...restForm } = this.Form;
            let params = {
              ...restForm,
              startTime: this.Form.serachTimer
                ? this.formatCreateTime(this.Form.serachTimer[0])
                : "",
              endTime: this.Form.serachTimer
                ? this.formatCreateTime(this.Form.serachTimer[1])
                : "",
            };
            if (this.editmark) {
              editOrderProductPromotionListPageApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].resetFields();
                  this.FormVisible = false;
                  this.getList();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            } else {
              addOrderProductPromotionListPageApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].resetFields();
                  this.FormVisible = false;
                  this.getList();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            }
          });
        }
      });
    },

    // 当省份改变时重新获取城市
    handleProvinceChange(val) {
      this.pid = val;
      this.getProvinceCityInfo(1);
    },
    // 当城市改变时获取区县
    handleCityChange(val) {
      this.pid = val;
      this.getProvinceCityInfo(2);
    },
    // 获取省市接口
    getProvinceCityInfo(type) {
      var params = {
        pid: this.pid,
      };
      return getAreaDictionaryList(params).then((res) => {
        if (type == 0) {
          this.provinceOptions = res.data.response;
        } else if (type == 1) {
          this.cityOptions = res.data.response;
        } else if (type == 2) {
          this.areaOptions = res.data.response;
        }
      });
    },

    viewOrderProductPromotionDetail(row) {
      this.$router.push({
        path: "/OrderProductPromotionDetail",
        query: { id: row.id },
      });
    },
    formatCreateTime: function (date) {
      return !date || date == ""
        ? ""
        : util.formatDate.format(new Date(date), "yyyy-MM-dd");
    },

    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },
  },
  mounted() {
    this.getList();
    this.getProvinceCityInfo(0);
    this.util = util;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style lang="stylus" scoped>
.rolesTop {
  width: 100%;
  display: flex;
}

.rolesInp {
  width: 300px;
  margin-right: 20px;
}

.pageBar {
  margin-top: 15px;
}
</style>
